// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__fCRsj","footer":"ModalUpdate_footer__3E2LJ"};